@if(isCompliant()) {
    <ui-streamline-icon class="text-success" [slIcon]="{ name: 'check-shield', theme: 'bold', size: 'lg'}"></ui-streamline-icon>
} @else {
    <ui-streamline-icon class="text-danger" [slIcon]="{ name: 'remove-shield', theme: 'bold', size: 'lg'}"></ui-streamline-icon>
}